import { render, staticRenderFns } from "./LunchBreak.vue?vue&type=template&id=9cb2b232&scoped=true&"
import script from "./LunchBreak.vue?vue&type=script&lang=js&"
export * from "./LunchBreak.vue?vue&type=script&lang=js&"
import style0 from "./LunchBreak.vue?vue&type=style&index=0&id=9cb2b232&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb2b232",
  null
  
)

export default component.exports